'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var Close = require('../../node_modules/@material-ui/icons/Close.js');
var React = require('react');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var IconButton = require('../../node_modules/@material-ui/core/esm/IconButton/IconButton.js');
var Snackbar = require('../../node_modules/@material-ui/core/esm/Snackbar/Snackbar.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var SnackBarCloseIcon = withStyles({
  root: {
    padding: 10
  }
})(IconButton["default"]);

function SimpleSnackbar(materialUIConfigurations) {
  var onClose = materialUIConfigurations.onClose;
  return React__default["default"].createElement(Snackbar["default"], _objectSpread({
    action: [React__default["default"].createElement(SnackBarCloseIcon, {
      key: "close",
      "aria-label": "Close",
      color: "inherit",
      onClick: onClose
    }, React__default["default"].createElement(Close, null))]
  }, materialUIConfigurations));
}

SimpleSnackbar.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  autoHideDuration: 6000,
  onClose: function onClose() {}
};

module.exports = SimpleSnackbar;
